import React from "react";

import Gradient from "@app/component/Gradient";
import gradient from "@app/scene/map/components/layers/HeatMap/util/gradient";

import styles from "./Range.module.scss";

interface Props {
  range: { max: number; min: number };
}

const Range: React.FC<Props> = ({ range }) => {
  return (
    <div className={styles.container}>
      <Gradient className={styles.gradient} gradient={gradient} />
      <div className={styles.labels}>
        <span>{range.min}</span>
        <span>{range.max}</span>
      </div>
    </div>
  );
};

export default Range;
